module.exports = __webpack_public_path__ + "assets/72437dfecf33f0f853d18a6e9c8843a6.png";